import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  loadComparisonHistory,
  toggleComparisonBookmark,
  updateComparisonInHistory,
} from 'shared/components/AICompare/comparisonStorage';
import ComparisonHistoryItem from 'shared/components/AICompare/ComparisonHistoryItem';
import ComparisonResultModal from 'shared/components/AICompare/ComparisonResultModal';
import ComparisonHistoryEmpty from './ComparisonHistoryEmpty';

import './ComparisonHistory.scss';
import 'shared/components/AICompare/AICompare.scss';

const FILTERS = {
  ALL: 'all',
  BOOKMARKED: 'bookmarked',
};

const ComparisonHistory = () => {
  const { t } = useTranslation();
  const [comparisons, setComparisons] = useState([]);
  const [filter, setFilter] = useState(FILTERS.ALL);
  const [selectedComparison, setSelectedComparison] = useState(null);

  useEffect(() => {
    setComparisons(loadComparisonHistory());
  }, []);

  const filteredComparisons = useMemo(() => {
    if (filter === FILTERS.BOOKMARKED) {
      return comparisons.filter(comparison => comparison.isBookmarked);
    }
    return comparisons;
  }, [filter, comparisons]);

  const handleToggleBookmark = comparisonId => {
    const updatedHistory = toggleComparisonBookmark(comparisonId);
    setComparisons(updatedHistory);
  };

  const handleSelectComparison = comparison => {
    setSelectedComparison(comparison);
  };

  const handleModalBookmarkToggle = updatedComparison => {
    updateComparisonInHistory(updatedComparison);
    setComparisons(prev => prev.map(item => (item.id === updatedComparison.id ? updatedComparison : item)));
    setSelectedComparison(updatedComparison);
  };

  return (
    <div className='comparison-history-page container'>
      <div className='page-header'>
        <h1 className='page-title'>{t('ai_compare.history_title')}</h1>
        <div className='header-actions'>
          <select className='filter-dropdown' value={filter} onChange={event => setFilter(event.target.value)}>
            <option value={FILTERS.ALL}>{t('ai_compare.filter_all')}</option>
            <option value={FILTERS.BOOKMARKED}>{t('ai_compare.filter_bookmarked')}</option>
          </select>
        </div>
      </div>

      <div className='comparisons-list'>
        {filteredComparisons.length === 0 ? (
          <ComparisonHistoryEmpty filter={filter} />
        ) : (
          filteredComparisons.map(comparison => (
            <ComparisonHistoryItem
              key={comparison.id}
              comparison={comparison}
              onToggleBookmark={handleToggleBookmark}
              onClick={() => handleSelectComparison(comparison)}
            />
          ))
        )}
      </div>

      {selectedComparison && (
        <ComparisonResultModal
          comparisonResult={selectedComparison}
          onClose={() => setSelectedComparison(null)}
          onViewHistory={() => setSelectedComparison(null)}
          onToggleBookmark={handleModalBookmarkToggle}
        />
      )}
    </div>
  );
};

export default ComparisonHistory;
